import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import './CSS/App.css';
import './CSS/Main.css';
import './languages/i18n';

import './CSS/Login_new.css'
import './CSS/Offer_new.css'
import './CSS/Start_page_new.css'
import './CSS/Start_page_new_mobile.css'
import './CSS/Profile_new.css'
import './CSS/Profile_new_mobile.css'
import './CSS/Promo_new.css'
import './CSS/Promo_new_mobile.css'

import './CSS/PanelStyle.css'

import YAuth from "./JS/registration/YAuth";
import YAuthMobile from "./JS/registration/YAuthMobile";

import StartPageNew from "./JS/StartPage";
import OfferNew from "./JS/OfferPage";

import LoginPage from "./JS/LoginPage";
import Profile from "./JS/ProfilePage";
import PromoPage from "./JS/PromoPage";
import CancelSubscriptionPage from "./JS/CancelSubscriptionPage";

import MobileShop from "./JS/Modile_pages/MobileShop";
import MobileProfile from "./JS/Modile_pages/MobileProfile";

import InstantPay from "./JS/InstantPay";
import InstantLogin from "./JS/InstantLogin";

import PanelLogin from "./JS/SupportPanel/PanelLogin";
import PanelSearch from "./JS/SupportPanel/PanelSearch";
import PanelUser from "./JS/SupportPanel/PanelUser";
import PanelReceipts from "./JS/SupportPanel/PanelReceipts";
import PanelInvited from "./JS/SupportPanel/PanelInvited";
import PanelLogs from "./JS/SupportPanel/PanelLogs";
import PanelPromo from "./JS/SupportPanel/PanelPromo";
import PanelSubscription from "./JS/SupportPanel/PanelSubscription";

function App() {

    return (
        <div style={{minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center'}}>
            <div style={{width: '100%'}}>
                <Router>
                    <Routes>
                        <Route path="/" element={<StartPageNew/>}/>
                        <Route path="" element={<StartPageNew/>}/>
                        <Route path="/tt" element={<StartPageNew/>}/>
                        <Route path="/yt" element={<StartPageNew/>}/>

                        <Route path="/login" element={<LoginPage/>}/>
                        <Route path="/profile" element={<Profile/>}/>
                        <Route path="/promo" element={<PromoPage/>}/>
                        <Route path="/cancel" element={<CancelSubscriptionPage/>}/>

                        <Route path="/offer" element={<OfferNew/>}/>

                        <Route path="/yauth" element={<YAuth/>}/>
                        <Route path="/yauth-mobile" element={<YAuthMobile/>}/>

                        <Route path="/mobileShop" element={<MobileShop/>}/>
                        <Route path="/mobileProfile" element={<MobileProfile/>}/>

                        <Route path="/instantPay" element={<InstantPay/>}/>
                        <Route path="/instantLogin" element={<InstantLogin/>}/>

                        <Route path="/panel-login" element={<PanelLogin/>}/>
                        <Route path="/panel-search" element={<PanelSearch/>}/>
                        <Route path="/panel-user" element={<PanelUser/>}/>
                        <Route path="/panel-receipts" element={<PanelReceipts/>}/>
                        <Route path="/panel-invited" element={<PanelInvited/>}/>
                        <Route path="/panel-logs" element={<PanelLogs/>}/>
                        <Route path="/panel-promo" element={<PanelPromo/>}/>
                        <Route path="/panel-subscription" element={<PanelSubscription/>}/>
                    </Routes>
                </Router>
            </div>
        </div>
    );
}
export default App;